import React from "react";
import { Modal } from "antd";
import { XIcon } from "../assets/icons";
import { Tabs } from "antd";
import "../../index.scss";
import "./terms-conditions/policy.scss";
import PrivacyPolicy from "./terms-conditions/PrivacyPolicyComponent";
import TermsServices from "./terms-conditions/TermsServicesComponent";
import CookiePolicy from "./terms-conditions/CookiePolicyComponent";
import { useTranslation } from "../i18n/LanguageContext";

function TermsConditionsModal({ visible, onCancel }) {
   const { t } = useTranslation();

   const tabs = [
      { key: "1", label: t("terms-of-service-tab-label"), content: <TermsServices /> },
      { key: "2", label: t("privacy-policy-tab-label"), content: <PrivacyPolicy /> },
      { key: "3", label: t("cookie-policy-tab-label"), content: <CookiePolicy /> }
   ];

   return (
      <Modal
         open={visible}
         footer={null}
         closable={false}
         onCancel={onCancel}
         width={560}
         className="modalAddSurveyStyle kap-terms-modal"
      >
         <button type="button" className="kap-terms-modal__close" onClick={onCancel}>
            <img src={XIcon} alt={t("close-icon-alt")} />
         </button>
         <Tabs
            defaultActiveKey="1"
            items={tabs.map(({ key, label, content }) => ({
               key,
               label,
               children: <div className="kap-terms-modal__body">{content}</div>
            }))}
         />
         <div className="kap-terms-modal__footer">
            <button
               type="button"
               onClick={onCancel}
               className="btn sign-btn font-weight-bold kap-terms-modal__ok"
            >
               {t("got-it-button")}
            </button>
         </div>
      </Modal>
   );
}

export default TermsConditionsModal;
